import { type ReactNode } from 'react';
import { PageUrl } from '../../../constants/PageUrl';
import { BlogCtaCard } from '../BlogCtaCard';
import { type ArticleCtaPosition } from '../BlogCtaCard/ctaPosition';
import { getArticleSlug } from '../BlogCtaCard/getArticleSlug';

type Props = {
  heading?: ReactNode;
  subtext?: string;
  ctaLabel?: string;
  ctaPosition?: ArticleCtaPosition;
};

const DEFAULT_HEADING = '子育ての悩み、ひとりで抱えていませんか？';
const DEFAULT_SUBTEXT = 'モンテチャットなら、モンテッソーリの専門家にAIで相談できます。';
const DEFAULT_CTA_LABEL = '詳しく見る';
const DEFAULT_HEADING_WITH_WBR = (
  <>
    子育ての悩み、
    <wbr />
    ひとりで抱えていませんか？
  </>
);

export const MonteChatCta = ({
  heading = DEFAULT_HEADING,
  subtext = DEFAULT_SUBTEXT,
  ctaLabel = DEFAULT_CTA_LABEL,
  ctaPosition,
}: Props) => {
  const renderedHeading = heading === DEFAULT_HEADING ? DEFAULT_HEADING_WITH_WBR : heading;

  const handleClick = () => {
    const articleSlug = getArticleSlug();
    const eventPayload: { event: string; article_slug?: string; cta_position?: ArticleCtaPosition } = {
      event: 'monte_chat_cta_click',
    };
    if (articleSlug) {
      eventPayload.article_slug = articleSlug;
    }
    if (ctaPosition !== undefined) {
      eventPayload.cta_position = ctaPosition;
    }

    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(eventPayload);
  };

  return (
    <BlogCtaCard
      theme="monteChat"
      ctaType="monte_chat"
      ctaPosition={ctaPosition}
      heading={renderedHeading}
      subtext={subtext}
      ctaLabel={ctaLabel}
      href={PageUrl.MONTE_CHAT_ROOT}
      imageSrc="/img/monte-chat-hero-image.webp"
      imageAlt="モンテチャットの利用イメージ"
      onCtaClick={handleClick}
    />
  );
};
